import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

import {ConstantService} from '../../constant/constant.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {

  constructor(
    private http: HttpClient,
    private constantService: ConstantService
  ) {
  }
  
  private _items: any = {};
  private _access: any = {};
  public loadInitialAccess: boolean = true;
  
  setItem(item: any) {
    this._items = item;
  }

  setAccess(item: any) {
    this._access = item;
    localStorage.setItem("USER_ACCESS",JSON.stringify(item));
  }
  
  getAccess() {
    return this._access;
  }

  getItems() {
    return this._items;
  }
  
  getAccessList(body: Object) {
    return this.http.post(this.constantService.getUrl(`${this.constantService.RBACPERMISSION}/access`), body);
  }
}
